import { SUBSCRIPTION_PRODUCTS, TOKENS_PRODUCTS } from '../utils/constants'
import makeRequest from './apiConfig'

const subscriptionEndpoints = {
  getSubscriptionInfo: '/api/subscription',
  updatePermissions: '/api/update-user-permissions',
  deleteSubscription: '/api/subscription/cancel',
  getAllSubscriptionProducts: '/api/products',
}

export const getSubscriptionInfo = async () => {
  try {
    const response = await makeRequest({
      method: 'GET',
      endpoint: subscriptionEndpoints.getSubscriptionInfo,
    })
    return response
  } catch (error) {
    console.error('Authentication failed:', error)
    throw error
  }
}

export const getAllSubscriptionProducts = async appId => {
  try {
    const response = await makeRequest({
      method: 'POST',
      endpoint: subscriptionEndpoints.getAllSubscriptionProducts,
      body: JSON.stringify({ products: [...SUBSCRIPTION_PRODUCTS(appId), ...TOKENS_PRODUCTS(appId)] }),
    })
    return response.products
  } catch (error) {
    console.error('Authentication failed:', error)
    return []
  }
}

export const updatePermissions = async body => {
  try {
    const response = await makeRequest({
      method: 'PUT',
      endpoint: subscriptionEndpoints.updatePermissions,
      body: JSON.stringify(body),
    })
    return response
  } catch (error) {
    console.error('Authentication failed:', error)
    throw error
  }
}

export const deleteSubscription = async () => {
  try {
    await makeRequest({
      method: 'DELETE',
      endpoint: subscriptionEndpoints.deleteSubscription,
    })
  } catch (error) {
    console.error('Authentication failed:', error)
    throw error
  }
}
